// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"494": "4077578422d4","5336": "5083bc5218c4","5448": "7c713db21d1d",}[chunkId] + ".css"
}